import { Component, OnInit, ViewChild } from '@angular/core';
import { LoyaltyPointsService } from 'OpsCenter/ops-support/loyalty-points/loyalty-points.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-loyalty-points',
  template: require('./loyalty-points.component.html'),
  styles: [require('./loyalty-points.component.less')],
})
export class LoyaltyPointsComponent implements OnInit {
  fileToUpload: File = null;
  jobStatus: Array<any>;
  isLoading = false;
  currentPage = 0;
  totalJobs: number;
  pageSize = this.loyaltyPointsService.PAGE_SIZE;

  @ViewChild('fileInput', { static: false })
  private fileInput: HTMLInputElement;

  constructor(private loyaltyPointsService: LoyaltyPointsService, private notificationService: ToastrService) {
  }

  ngOnInit(): void {
    this.retrieveJobStatus(this.currentPage);
  }

  retrieveJobStatus(page: number) {
    if (this.isLoading) {
      return;
    }

    this.enableLoading();
    this.loyaltyPointsService.getJobStatus(page.toString()).subscribe(res => this.handleJobStatus(res),
      () => this.handleError('There was an error retrieving job status.'));
  }

  onFileSelected(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  onUploadButtonClicked() {
    if (this.isLoading) {
      return;
    }

    this.enableLoading();
    this.loyaltyPointsService.uploadFile(this.fileToUpload).subscribe(() => {
      this.handleSuccess();
      this.retrieveJobStatus(this.currentPage - 1);
    }, () => this.handleError('There was an error uploading this file. Please try again.'));
  }

  private handleJobStatus(data: any) {
    this.totalJobs = data.total;
    this.jobStatus = data.items;
    this.currentPage = data.page + 1;
    this.disableLoading();
  }

  private handleSuccess() {
    this.notificationService.success('The file was successfully uploaded.');
    this.clearForm();
    this.disableLoading();
  }

  private handleError(message: string) {
    this.notificationService.error(message);
    this.disableLoading();
  }

  private clearForm() {
    this.fileToUpload = null;
    this.fileInput.value = '';
  }

  private enableLoading() {
    this.isLoading = true;
  }

  private disableLoading() {
    this.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/ops-support/loyalty-points/loyalty-points.component.ts